import type { ProductImportResultDTO } from '@wberp/shared';

// Request size and concurrency controls, not a limit on an import session.
const REQUEST_LINKS = 50;

export function parseProductImportLinks(text:string):string[] {
  const seen=new Set<string>(),urls:string[]=[];
  for(const value of text.split(/[\s,]+/u).filter(Boolean)) {
    let key=value;
    try {
      const url=new URL(value),host=url.hostname.toLowerCase().replace(/\.$/u,'');
      const id=url.pathname.match(/\/offer\/(\d+)(?:\.html)?/iu)?.[1]||url.searchParams.get('offerId')||url.searchParams.get('offerid');
      if(/^https?:$/u.test(url.protocol)&&(host==='1688.com'||host.endsWith('.1688.com'))&&id&&/^\d{8,20}$/u.test(id))key=`1688:${id}`;
    } catch { /* Keep invalid input for the server's ordinary result accounting. */ }
    if(!seen.has(key)){seen.add(key);urls.push(value);}
  }
  return urls;
}

export type ProductImportSession={urls:string[];submitted:number;result:ProductImportResultDTO};
export type ProductImportProgress=Pick<ProductImportSession,'submitted'>&{total:number;accepted:number;duplicates:number;invalid:number;rejected:number};

export function createProductImportSession(urls:string[]):ProductImportSession {
  return {urls,submitted:0,result:{accepted:0,duplicates:0,invalid:0,rejected:0,productIds:[],restoreRequiredIds:[],modeConflictIds:[]}};
}

/** Resume at the first unacknowledged request. If a response was lost, server
 * product uniqueness makes re-submitting that one request safe. */
export async function submitProductImportSession(session:ProductImportSession,send:(urls:string[])=>Promise<ProductImportResultDTO>,
  report:(progress:ProductImportProgress)=>void=()=>{},shouldContinue:()=>boolean=()=>true):Promise<ProductImportResultDTO> {
  const progress=()=>report({submitted:session.submitted,total:session.urls.length,accepted:session.result.accepted,
    duplicates:session.result.duplicates,invalid:session.result.invalid,rejected:session.result.rejected});
  progress();
  while(session.submitted<session.urls.length&&shouldContinue()) {
    const chunk=session.urls.slice(session.submitted,session.submitted+REQUEST_LINKS);
    const result=await send(chunk);
    session.result.accepted+=result.accepted;session.result.duplicates+=result.duplicates;
    session.result.invalid+=result.invalid;session.result.rejected+=result.rejected;
    session.result.productIds.push(...result.productIds);session.result.restoreRequiredIds.push(...result.restoreRequiredIds);
    session.result.modeConflictIds!.push(...result.modeConflictIds??[]);
    session.submitted+=chunk.length;
    progress();
  }
  return session.result;
}
